export class Document {
    constructor(
        public name?: String,
        public id?: String,
		public parentId?: String,
		public text?: String,
		public type?: String  ) {}
}